import React from "react";
import { Award, Leaf, Globe, PenTool, Handshake, Zap, ArrowRight } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Card, CardHeader, CardTitle, CardDescription, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const features = [{
  title: "Immediate Stress Relief",
  description: "We provide instant clarity and relief from the weight of legal burdens through expert guidance and support.",
  icon: <Award className="size-6 text-chart-3" />
}, {
  title: "Legal Expertise",
  description: "Access a team of dedicated specialists committed to navigating complex regulations on your behalf with precision.",
  icon: <Leaf className="size-6 text-chart-3" />
}, {
  title: "Direct Resolution Paths",
  description: "We streamline the path to resolution, focusing on efficient outcomes that save you valuable time and energy.",
  icon: <Globe className="size-6 text-chart-3" />
}, {
  title: "Personalized Strategy",
  description: "Receive a tailored approach designed to meet your specific goals and unique circumstances with strategic insight.",
  icon: <PenTool className="size-6 text-chart-3" />
}, {
  title: "Confidential Guidance",
  description: "Trust in a secure partnership where your privacy and sensitive information are strictly protected at all times.",
  icon: <Handshake className="size-6 text-chart-3" />
}, {
  title: "Transparent Process",
  description: "Experience complete visibility with regular updates and clear explanations at every stage of your resolution journey.",
  icon: <Zap className="size-6 text-chart-3" />
}];
export default function ValuesExpertise() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="24310" id="benefits-overview" className="bg-background text-foreground py-16 md:py-24" ref={ref}>
      <div className="container mx-auto px-4 md:px-6">
        <div className={`max-w-3xl mx-auto text-center mb-16 transition-all duration-700 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}>
          <h2 className="text-3xl md:text-4xl font-default font-bold tracking-tight text-foreground mb-4">
            Our Core Benefits & Strategic Value
          </h2>
          <p className="text-lg text-muted-foreground font-default">
            We combine years of specialized practice with a client-focused approach to deliver resolution paths that restore your peace of mind.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8">
          {features.map((feature, i) => <div key={i} data-index={i} className={`transition-all duration-700 delay-[${i * 100}ms] ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}>
              <Card className="h-full border border-border/50 bg-card hover:bg-card hover:shadow-xl transition-all duration-300 group">
                <CardHeader>
                  <div className="mb-4 inline-flex items-center justify-center size-12 rounded-full bg-transparent group-hover:bg-background transition-colors">
                    {feature.icon}
                  </div>
                  <CardTitle className="text-xl font-default font-semibold text-primary group-hover:text-primary transition-colors">
                    {feature.title}
                  </CardTitle>
                </CardHeader>
                <CardContent>
                  <CardDescription className="text-base leading-relaxed font-default text-muted-foreground">
                    {feature.description}
                  </CardDescription>
                </CardContent>
              </Card>
            </div>)}
        </div>

        <div className={`mt-16 text-center transition-all duration-700 delay-500 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}>
          <Button asChild size="lg" className="rounded-full px-8 font-default">
            <Link to="/AboutPage">
              Learn More About Our Approach
              <ArrowRight className="ml-2 size-4" />
            </Link>
          </Button>
        </div>
      </div>
    </section>;
}